import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "table", "label", "revealMore", "revealLess", "revealButton"];

  connect() {
    this.hiddenLabels = this.labelTargets.filter((label) => this.startsHidden(label));
    this.setExpanded(this.hiddenLabels.some((label) => !label.classList.contains("hidden")));
    this.toggleTargets.forEach((checkbox) => this.applyColumn(checkbox));
  }

  toggle(event) {
    this.applyColumn(event.target);
  }

  showAll() {
    this.setAll(true);
  }

  hideAll() {
    this.setAll(false);
  }

  toggleHidden() {
    this.setExpanded(!this.expanded);
  }

  setExpanded(expanded) {
    this.expanded = expanded;

    this.hiddenLabels.forEach((label) => {
      label.classList.toggle("hidden", !expanded);
      label.classList.toggle("inline-flex", expanded);
    });

    if (this.hasRevealMoreTarget) this.revealMoreTarget.classList.toggle("hidden", expanded);
    if (this.hasRevealLessTarget) this.revealLessTarget.classList.toggle("hidden", !expanded);
    if (this.hasRevealButtonTarget) this.revealButtonTarget.setAttribute("aria-expanded", expanded);
  }

  setAll(checked) {
    this.toggleTargets.forEach((checkbox) => {
      checkbox.checked = checked;
      this.applyColumn(checkbox);
    });

    this.setExpanded(true);
  }

  applyColumn(checkbox) {
    const index = checkbox.dataset.columnIndex;
    const hidden = !checkbox.checked;

    this.tableTarget
      .querySelectorAll(`[data-column-index="${index}"]`)
      .forEach((cell) => cell.classList.toggle("hidden", hidden));
  }

  startsHidden(label) {
    const checkbox = label.querySelector("input[type=checkbox]");

    return checkbox ? !checkbox.defaultChecked : false;
  }
}
